module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "BuildingEdit"
    }
  }, [_c('div', {
    staticClass: "headLine"
  }, [_vm._v("新增产业空间信息")]), _vm._v(" "), (_vm.auditRecord != '') ? _c('div', {
    staticClass: "backLine"
  }, [_vm._v("\n    退回原因：" + _vm._s(_vm.auditRecord) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navLine"
  }, [_c('div', {
    class: ['navItem', {
      act: _vm.navAct == 1
    }],
    on: {
      "click": function($event) {
        _vm.navChange(1)
      }
    }
  }, [_vm._v("\n      楼宇信息\n    ")]), _vm._v(" "), _c('div', {
    class: ['navItem', {
      act: _vm.navAct == 2
    }],
    on: {
      "click": function($event) {
        _vm.navChange(2)
      }
    }
  }, [_c('span', [_vm._v("空间信息（" + _vm._s(_vm.floors) + "）")])])]), _vm._v(" "), _c('div', {
    staticClass: "pgContent"
  }, [_c('Buliding', {
    ref: "buliding",
    attrs: {
      "resData": _vm.resData,
      "hidden": _vm.navAct == 2
    }
  }), _vm._v(" "), _c('Floor', {
    ref: "floor",
    attrs: {
      "resData": _vm.resData,
      "hidden": _vm.navAct == 1
    },
    on: {
      "floors": _vm.floorChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pgFooter"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.bulidingSave(4)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.bulidingSave(5)
      }
    }
  }, [_vm._v("提交审核")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.pgBack
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-84394690"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingEdit/index.vue
// module id = 1538
// module chunks = 1